export default {
  path: '/smlq',
  name: 'ScanCoupon',
  meta: { title: '扫一扫', show: true, noCard: true },
  // 生产环境
  component: () => import('@/views/Scan/Coupon')
  // 测试环境
  // component: () => import('@/views/Scan/Coupon/test.vue')
}
